import React from 'react';
import cn from 'classnames';

import { Icons } from '@icons/icons';

import { IWarningMessageProps } from './WarningMessage.types';

import './WarningMessage.scss';

const WarningMessage: React.FC<IWarningMessageProps> = ({
	content,
	customClassName = '',
}) => {
	const wrapperClasses = cn('f5gWarningMessageContainer', {
		[`${customClassName}`]: customClassName,
	});

	return (
		<div className={wrapperClasses}>
			<div className='f5gWarningMessageIcon'>
				{Icons.smallWarningIcon()}
			</div>
			<div className='f5gWarningMessageContent'>
				{content}
			</div>
		</div>
	);
};

export default WarningMessage;
